// En-tete fixe et reducteur au defilement.
// Pages concernees : celles que layout/theme.liquid marque avec
// page--entete-fixe (collections et fiches produit).
(function() {
  /* ON NE DEVINE PLUS D'APRES L'ADRESSE.
     L'ancien test cherchait "/collections/" dans l'URL : les fiches
     produit, en /products/..., n'etaient donc jamais concernees, et il
     fallait penser a modifier deux endroits. On se fie maintenant a la
     classe posee par le serveur, seul endroit ou la liste des pages est
     decidee. */
  if (!document.body || !document.body.classList.contains('page--entete-fixe')) return;
  
  const header = document.querySelector('[id*="shopify-section"][id*="header"]');
  const headerWrapper = document.querySelector('.header-wrapper');
  const logo = document.querySelector('.header__heading-logo');
  const cartIcon = document.querySelector('.header__icon--cart');
  const hamburgerIcon = document.querySelector('.header-menu-toggle');
  const subnav = document.querySelector('.header-subnav');

  // Sous-menu horizontal : valeurs au repos / une fois reduit.
  // (les memes noms de variables CSS sont definis dans sections/header.liquid)
  const SUBNAV = {
    font:    { from: 9.5, to: 8,   unit: 'px' },
    gap:     { from: 18,  to: 11,  unit: 'px' },
    // padding applique EN HAUT ET EN BAS : la barre reste centree.
    padding: { from: 5,   to: 2.5, unit: 'px' }
  };
  const SUBNAV_MOBILE = {
    font:    { from: 9,   to: 8,   unit: 'px' },
    gap:     { from: 14,  to: 9,   unit: 'px' },
    padding: { from: 4,   to: 2,   unit: 'px' }
  };

  function lerp(range, percent) {
    return (range.from - (range.from - range.to) * percent).toFixed(2) + range.unit;
  }
  
  if (!header) return;
  
  // Filet : la meme classe cote en-tete, pour les regles CSS de repli
  // si jamais la classe du <body> venait a manquer.
  header.classList.add('header--entete-fixe');
  
  const groupeEntete = document.querySelector('.shopify-section-group-header-group');

  /* PLACE RESERVEE SOUS L'EN-TETE.
     L'en-tete etant en position: fixed, il est sorti du flux : c'est a
     nous de laisser sa place, sinon le contenu passe dessous. La valeur
     etait ecrite en dur dans le CSS (96 px) et ne correspondait plus a
     la hauteur reelle. On la MESURE donc, et on ne reecrit la variable
     que si elle differe de ce que le CSS prevoyait - sans quoi on
     reintroduirait le saut au chargement qu'on avait corrige.
     On ne mesure qu'au repos : une fois l'en-tete reduit, sa hauteur
     n'est plus celle qu'il faut reserver. */
  function reserverLaPlace() {
    if (!groupeEntete) return;
    if ((window.pageYOffset || document.documentElement.scrollTop || 0) > SCROLL_START) return;

    const mesuree = Math.round(groupeEntete.getBoundingClientRect().height);
    if (!mesuree) return;

    const prevue = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--entete-hauteur')
    ) || 0;
    if (Math.abs(mesuree - prevue) < 2) return;

    document.documentElement.style.setProperty('--entete-hauteur', mesuree + 'px');
  }

  let ticking = false;
  
  // Détecter si on est sur mobile
  const isMobile = window.innerWidth <= 768;
  
  const INITIAL_LOGO_WIDTH = 50;
  const SHRUNK_LOGO_WIDTH = 30;
  const INITIAL_PADDING = 0;
  const SHRUNK_PADDING = 0;
  
  // Valeurs différentes selon mobile/desktop
  const SCROLL_START = isMobile ? 5 : 5;
  const SCROLL_DISTANCE = isMobile ? 100 : 200;
  
  function updateHeader() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // Calculer le pourcentage de réduction (0 à 1)
    let shrinkPercent = 0;
    if (scrollTop > SCROLL_START) {
      shrinkPercent = Math.min((scrollTop - SCROLL_START) / SCROLL_DISTANCE, 1);
    }
    
    const currentLogoWidth = INITIAL_LOGO_WIDTH - (INITIAL_LOGO_WIDTH - SHRUNK_LOGO_WIDTH) * shrinkPercent;
    const currentPadding = INITIAL_PADDING - (INITIAL_PADDING - SHRUNK_PADDING) * shrinkPercent;
    
    if (logo) {
      logo.style.width = `${currentLogoWidth}px`;
      logo.style.height = 'auto';
      logo.style.transition = 'none';
    }
    
    if (cartIcon) {
      const iconScale = 1 - (0.20 * shrinkPercent);
      cartIcon.style.transform = `scale(${iconScale})`;
      cartIcon.style.transformOrigin = 'center';
      cartIcon.style.transition = 'none';
    }
    
    // Faire disparaître le compteur au scroll
    const cartCount = document.querySelector('#cart-icon-bubble .cart-count-hand');
    if (cartCount) {
      const countOpacity = 1 - shrinkPercent;
      cartCount.style.opacity = countOpacity;
      cartCount.style.transition = 'none';
    }

    // Réduire l'icône hamburger aussi
    if (hamburgerIcon) {
      const hamburgerScale = 1 - (0.20 * shrinkPercent);
      hamburgerIcon.style.transform = `translateY(-50%) scale(${hamburgerScale})`;
      hamburgerIcon.style.transformOrigin = 'left center';
      hamburgerIcon.style.transition = 'none';
    }
    
    // Le sous-menu horizontal se resserre en meme temps que le reste
    if (subnav) {
      const s = window.innerWidth <= 768 ? SUBNAV_MOBILE : SUBNAV;
      subnav.style.setProperty('--subnav-font', lerp(s.font, shrinkPercent));
      subnav.style.setProperty('--subnav-gap', lerp(s.gap, shrinkPercent));
      subnav.style.setProperty('--subnav-pad-y', lerp(s.padding, shrinkPercent));
      subnav.style.transition = 'none';
    }

    if (headerWrapper) {
      headerWrapper.style.paddingTop = `${currentPadding}px`;
      headerWrapper.style.paddingBottom = `${currentPadding}px`;
      headerWrapper.style.transition = 'none';
    }
    
    if (shrinkPercent > 0) {
      header.classList.add('header--shrunk');
    } else {
      header.classList.remove('header--shrunk');
    }
    
    ticking = false;
  }
  
  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }
  
  // Attendre que tout soit chargé avant d'initialiser
  window.addEventListener('load', function() {
    reserverLaPlace();
    updateHeader();
  });
  
  // Initialiser aussi immédiatement au cas où
  setTimeout(function() {
    reserverLaPlace();
    updateHeader();
  }, 0);
  
  window.addEventListener('scroll', requestTick, { passive: true });

  /* La hauteur de l'en-tete change avec la largeur de l'ecran (le
     sous-menu se resserre, le logo change de taille). */
  let minuterieTaille = null;
  window.addEventListener('resize', function() {
    if (minuterieTaille) clearTimeout(minuterieTaille);
    minuterieTaille = setTimeout(reserverLaPlace, 150);
  });
})();
